const required = value => value ? undefined : 'Required'

const maxValue = max => value =>
  value && value > max ? `Must be less than ${max}` : undefined

export const maxDecimalValue = maxValue(1000000000000);                                         

export default required;